export default function BeatPlanReducer(state, action) {
    //console.log('STATE  : ', state)
    switch (action.type) {

      case 'GET_ALL_BEAT_PLANS':
        console.log("in reducer");
        return {
          ...state,
          beatPlans: action.payload,
          loading: false,
        }
      case 'ADD_BEAT_PLAN':
        console.log("reducer", state, action.payload)
        return {
          ...state,
          beatPlans: [action.payload, ...state.beatPlans],
          loading: false,
        }
      default:
        return state
    }
  }
  